import VideoGreen from './VideoGreen'
import VideoGrey from './VideoGrey'
import VideoRed from './VideoRed'
import VideoStart from './VideoStart'
import Permission from './Permission'
import Error from './Error'
import SettingIcon from './Setting'

export default {
    VideoGreen,
    VideoGrey,
    VideoRed,
    VideoStart,
    Permission,
    Error,
    SettingIcon
}
